'use client';

import { c as _c } from "react/compiler-runtime";
import IconMoreAction from '@/components/assets/icon_more_action.svg';
import PopoverMenu from '@/components/PopoverMenu';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import ViverseIconButton from '@/components/ViverseIconButton';
import { useAuthContext } from '@/context/AuthContext';
import { useConfigsContext } from '@/context/ConfigsContext';
import { cn } from '@/lib/utils';
import { Comment } from '@/types/comments';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useIsClient } from 'usehooks-ts';
type CommentMoreActionsButtonProps = {
  comment: Comment;
  handleDelete: () => void;
  handleReport: () => void;
};
function CommentMoreActionsButton(t0) {
  const $ = _c(26);
  const {
    comment,
    handleDelete,
    handleReport
  } = t0;
  const t = useTranslations();
  const {
    isSignedIn
  } = useAuthContext();
  const {
    store
  } = useConfigsContext();
  const [open, setOpen] = useState(false);
  const isClient = useIsClient();
  const isMyComment = comment.owner.id === store?.profile?.id;
  const t1 = open && "bg-vive-primary-60";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !isClient || !isSignedIn;
  const t4 = open && "fill-vive-brand-50 group-hover:fill-vive-brand-50";
  let t5;
  if ($[2] !== t4) {
    t5 = cn("fill-vive-primary-20 group-hover:fill-vive-white group-active:fill-vive-brand-50", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <IconMoreAction width={20} height={20} className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t6) {
    t7 = <PopoverTrigger asChild={true}><ViverseIconButton size="S" variant="empty" className={t2} disabled={t3}>{t6}</ViverseIconButton></PopoverTrigger>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleReport || $[11] !== isMyComment || $[12] !== isSignedIn || $[13] !== t) {
    t8 = isSignedIn && !isMyComment && <PopoverMenu.Item className="rounded-none" onClick={() => {
      handleReport();
      setOpen(false);
    }}><div className="body-1 text-inherit">{t("comment-more-action.report")}</div></PopoverMenu.Item>;
    $[10] = handleReport;
    $[11] = isMyComment;
    $[12] = isSignedIn;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleDelete || $[16] !== isMyComment || $[17] !== t) {
    t9 = isMyComment && <PopoverMenu.Item className="rounded-none" onClick={() => {
      handleDelete();
      setOpen(false);
    }}><div className="body-1 text-inherit">{t("comment-more-action.delete")}</div></PopoverMenu.Item>;
    $[15] = handleDelete;
    $[16] = isMyComment;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <PopoverContent side="bottom" align="end" className="mt-2 border-none bg-transparent p-0"><PopoverMenu className="bg-vive-primary-70 rounded-[3px] p-2"><PopoverMenu.Group>{t8}{t9}</PopoverMenu.Group></PopoverMenu></PopoverContent>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== open || $[23] !== t10 || $[24] !== t7) {
    t11 = <><Popover open={open} onOpenChange={setOpen}>{t7}{t10}</Popover></>;
    $[22] = open;
    $[23] = t10;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export default CommentMoreActionsButton;